import type { StrategyField } from "@/lib/api/building";

// Shared labels/units for BuildingTarget strategy fields — used by the strategy editor,
// the recommendation proposals, and the Strategia perspective's rajat-vs-nykytila card.
export const STRATEGY_FIELD_LABELS: Record<
  StrategyField,
  { label: string; unit: string }
> = {
  consumption_kwh_m2_year: {
    label: "Energiatehokkuustavoite",
    unit: "kWh/m²/v",
  },
  // Story #1758: these three now double as the per-käyttöaste-step bounds table's implicit
  // default step (docs/spec/knowledge-base.md § Zone KPI steps -> Bounds decision) whenever that
  // step's own `BuildingTarget.step_bounds` entry is unset — labelled "(oletus)" so the editor
  // reads as the fallback, not a fourth independent bound. The retired occupied/unoccupied pair
  // is gone; per-step editing lives in OptimizationStrategySection.
  comfort_temp_min: { label: "Min. lämpötila (oletus)", unit: "°C" },
  comfort_temp_max: { label: "Max. lämpötila (oletus)", unit: "°C" },
  co2_limit_ppm: { label: "CO₂-raja (oletus)", unit: "ppm" },
  peak_power_cap_kw: { label: "Huipputehoraja", unit: "kW" },
  savings_goal_eur_year: { label: "Säästötavoite", unit: "€/v" },
};

export const STRATEGY_FIELDS = Object.keys(
  STRATEGY_FIELD_LABELS,
) as StrategyField[];

// Labels for a `StrategyStepBound`'s three fields — generic bound-kind copy (not a step's own
// name_fi, which comes from the KB, never from here). Used once per non-default käyttöaste step
// the KB reports (OptimizationStrategySection).
export const STRATEGY_STEP_BOUND_FIELD_LABELS: Record<
  "temp_min" | "temp_max" | "co2_limit_ppm",
  { label: string; unit: string }
> = {
  temp_min: { label: "Min. lämpötila", unit: "°C" },
  temp_max: { label: "Max. lämpötila", unit: "°C" },
  co2_limit_ppm: { label: "CO₂-raja", unit: "ppm" },
};
